export default __webpack_public_path__ + "static/media/smart-makers-anos-finais-blue.3c536419.jpg";